exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notify-wrapper {\n    position: fixed;\n    top:0;\n    right:0;\n    padding-top:20px;\n    padding-right:0px;\n    padding-bottom:20px;\n    z-index: 1119;\n}\n.alert {\n    width:400px;\n    border:none;\n    border-radius: inherit;\n    box-shadow: 3px 4px 6px -3px  rgba(0,0,0,0.75);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/notify/notify.component.css
// module id = 447
// module chunks = 0